<template>
  <div class="pattern-gallery">
    <template v-for="p in patterns">
      <router-link :to="getPatternLink(p)" class="link">
        <div class="preview">
          <div v-html="p.preview"></div>
          <div class="caption-container">
            <div class="caption alt-font">{{ p.name }}</div>
          </div>
        </div>
        <div class="alt-font">{{ p.name }}</div>
      </router-link>
    </template>
  </div>
</template>

<script>
import patterns from '../lib/filzfelt/patterns'
import spPatterns from '../lib/spinneybeck/patterns'

export default {
  computed: {
    patterns() {
      if (this.$store.getters.brand === 'filzfelt') {
        return patterns
          .sort((a, b) => {
            return a.name.localeCompare(b.name)
          })
      }
      return spPatterns
    }
  },
  methods: {
    getPatternLink({ id, name }) {
      const slug = name.replace(/\s+/g, '-').toLowerCase()
      return { name: 'edit', params: { id, slug } }
    }
  }
}
</script>

<style lang="postcss" scoped>
.pattern-gallery {
  display: flex;
  flex-wrap: wrap;
  margin: -7px -10px;

  &>* {
    margin: 7px 10px;
  }
}

.link {
  display: block;
  color: inherit;
  text-decoration: inherit;
}

.preview {
  position: relative;
  display: block;
  width: 300px;
  height: 200px;
  background: #f7f7f7;
}

.caption-container {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.caption {
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #fff;
  visibility: hidden;
}

.link:matches(:hover, :focus) {
  & .preview {
    background: #45758f;
  }

  & .caption {
    visibility: visible;
  }
}
</style>

<style lang="postcss">
@import "../styles/vars.css";

.pattern-gallery {
  & svg {
    width: 300px;
    height: 200px;
  }

  & polygon {
    stroke: var(--color-main);
    stroke-width: var(--stroke-width);
  }

  & path {
    fill: none;
    stroke: var(--color-main);
    stroke-width: calc(var(--stroke-width));
  }

  & rect {
    fill: none;
    stroke: var(--color-main);
    stroke-width: calc(var(--stroke-width));
  }
}

.link:hover {
  .caption-container {
    background-color: rgba(69, 117, 143, 0.8);
  }
}
</style>



// WEBPACK FOOTER //
// PatternGallery.vue?7326ae07